import { BindingSpherum } from 'reactApp/components/BindingSpherum/BindingSpherum';
import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';

export const renderBindingSpherum = renderModalDialog(BindingSpherum, 'BindingSpherumDialog');
